module.exports = __webpack_public_path__ + "img/icon-languages.a80ab074.svg";